import axios, { endpoints } from 'src/lib/axios';

import { setSession } from './utils';
import { JWT_STORAGE_KEY } from './constant';
import {RoleType} from "../../types/user";

// ----------------------------------------------------------------------

export type SignInParams = {
  email: string;
  password: string;
};

export type SignUpParams = {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
};

/** **************************************
 * Sign in
 *************************************** */
export const signInWithPassword = async ({ email, password }: SignInParams): Promise<void> => {
  try {
    const params = { email, password, os: "web" };

    const res = await axios.post(endpoints.auth.signIn, params);

    console.log("RESPONSE LOGIN",res.data);

    const data = res.data.data;

    if (!data.token) {
      throw new Error('Token valido');
    }

    if(data.user.role === RoleType.Amministratore.toString() ||
      data.user.role === RoleType.Backoffice.toString() ||
      data.user.role === RoleType.Consulente.toString() ||
      data.user.role === RoleType.Beginner.toString()
    ){
      if(data.user.active === 1 || data.user.active === "1"){
        setSession(data.token);
      }else{
        throw new Error('Utente non abilitato');
      }
    }else{
      throw new Error('Ruolo non abilitato');
    }
  } catch (error) {
    console.error('Errore durante il login:', error);
    throw error;
  }
};

/** **************************************
 * Sign up
 *************************************** */
export const signUp = async ({
  email,
  password,
  firstName,
  lastName,
}: SignUpParams): Promise<void> => {
  const params = {
    email,
    password,
    firstName,
    lastName,
    os: "web"
  };

  try {
    const res = await axios.post(endpoints.auth.signUp, params);

    const { accessToken } = res.data;

    if (!accessToken) {
      throw new Error('Access token not found in response');
    }

    sessionStorage.setItem(JWT_STORAGE_KEY, accessToken);
  } catch (error) {
    console.error('Error during sign up:', error);
    throw error;
  }
};

/** **************************************
 * Sign out
 *************************************** */
export const signOut = async (): Promise<void> => {
  try {
    await setSession(null);
  } catch (error) {
    console.error('Error during sign out:', error);
    throw error;
  }
};
